export default __webpack_public_path__ + "static/media/plant-circle.82b432bb.svg";